import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';

export default class TopicList extends Component {
  navigateToTopic(event, href) {
    if (
      event.defaultPrevented ||
      (event.button !== undefined && event.button !== 0) ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    // A discussion page can leave the index list state cached for another
    // topic. Recreate the index from the target URL so its first request uses
    // the clicked topic filter.
    event.preventDefault();
    window.location.assign(href);
  }

  view() {
    return (
      <div className="SpacePocketPosts-topicList">
        {this.attrs.topics.map((topic) => {
          const href = topic.id ? app.route('index', { topic: topic.id, topicName: topic.name }) : null;

          return href ? (
            <Link
              className="SpacePocketPosts-topicLink"
              href={href}
              key={topic.id}
              onclick={(event) => this.navigateToTopic(event, href)}
            >
              <span aria-hidden="true">#</span>{topic.name}
            </Link>
          ) : (
            <span className="SpacePocketPosts-topicLink" key={topic.name}>
              <span aria-hidden="true">#</span>{topic.name}
            </span>
          );
        })}
      </div>
    );
  }
}
